 $(document).ready(function(){
   
  
   setTimeout( function() {
       $(".l_c_h").animate({
               bottom: "18px",
       }, 1200);
   }, 15000);
   
   // This is the automatic blue popup 
//    setTimeout( function() {
//      $(".modal-overlay7").show();
//    }, 6000);
   
   /*jQuery(".c_h").click(function(e) {
     if (jQuery(".chat_container").is(":visible")) {
       jQuery(".c_h .right_c .mini").text("+")
     } else {
       jQuery(".c_h .right_c .mini").text("-")
     }
     jQuery(".chat_container").slideToggle("slow");
     return false
   });*/
   
   
   var elements = jQuery('.modal-overlay, .modal');

   jQuery('.socialimplactpop a').click(function(){
     elements.addClass('active');
   });

   jQuery('.close-modal').click(function(){
     elements.removeClass('active');
   });


   var elements1 = jQuery('.modal-overlay1, .modal1');

   jQuery('.podcastpop a').click(function(){
     elements1.addClass('active');
   });

   jQuery('.close-modal').click(function(){
     elements1.removeClass('active');
   });


   var elements2 = jQuery('.modal-overlay2, .modal2');

//    jQuery('.podcastpop1').click(function(){
//      elements2.addClass('active');
//    });

   jQuery('.close-modal').click(function(){
     elements2.removeClass('active');
   });


   var elements3 = jQuery('.modal-overlay3, .modal3');

   jQuery('.ybqpop').click(function(){
     elements3.addClass('active');
   });

   jQuery('.close-modal').click(function(){
     elements3.removeClass('active');
   });


   var elements4 = jQuery('.modal-overlay5, .modal5');

   jQuery('.joinlist').click(function(){
     elements4.addClass('active');
   });

   jQuery('.close-modal').click(function(){
     elements4.removeClass('active');
   });



   var elements5 = jQuery('.sidebarpopup');

   jQuery('.left_icons').click(function(){
     elements5.addClass('hide');
   });
   
   
   /******** Pre Order kit ********/
  
  var elements6 = jQuery('.modal-overlay4, .modal4');

  jQuery('.preorderkit a').click(function(){
    elements6.addClass('active');
  });

  jQuery('.close-modal').click(function(){
    elements6.removeClass('active');
  });  
   
   
   var elements8 = jQuery('.modal-overlay6, .modal6');

   jQuery('.preorderkit1 a').click(function(){
     elements8.addClass('active');
   });

   jQuery('.close-modal').click(function(){
     elements8.removeClass('active');
   }); 
  
  /******** Pre Order kit ********/
   
   
   var elements7 = jQuery('.modal-overlay7');

   jQuery('#cbutton').click(function(){
     elements7.addClass('hide');
   });
  
   
   $(".bodyboard a").click(function() {
     $('html, body').animate({
       scrollTop: $(".testimonialsec").offset().top
     }, 2000);
   });
   
   
  
   
   
});


  